import classNames from 'classnames/bind'

export default (styles: Record<string, string>) => classNames.bind(styles)
